// Delegated scope exposed by the FLW Orchestrator AAD app
// This must be registered under "Expose an API" and granted to the client

export type { PolicyEvaluateRequest } from './flw-orchestrator.request';
export type { PolicyType, MfaReason, MamReason, PolicyEvaluateResponse, TenantGeoRegionResponse } from './flw-orchestrator.response';

export enum Environment {
  INT = 'INT',
  PPE = 'PPE',
  PROD = 'PROD',
}

// Base URLs for each environment
export const FLW_ORCHESTRATOR_URLS: Record<Environment, string> = {
  [Environment.INT]: 'https://flworchestrator-int.teams.microsoft.com',
  [Environment.PPE]: 'https://flworchestrator-ppe.teams.microsoft.com',
  [Environment.PROD]: 'https://flworchestrator.teams.microsoft.com',
};

// API paths relative to the base URL
export const FLW_API_PATHS = {
  MFA_EVALUATE: '/api/v1.0/flw/policies/mfa/evaluate',
  MAM_EVALUATE: '/api/v1.0/flw/policies/mam/evaluate',
  TENANT_GEO_REGION: '/api/v1.0/tenantgeoregion',
} as const;

/**
 * Device types selected by the user during onboarding
 */
export enum Device {
  ANDROID = 'android',
  IOS = 'ios'
}

/**
 * Device platform types used in policy evaluation
 */
export enum DevicePlatform {
  ANDROID = 'android',
  IOS = 'iOS'
}

/**
 * Policy evaluation step types
 */
export enum PolicyEvaluationStep {
  MFA = 'mfa',
  MAM = 'mam'
}
